import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';


export default function Method(props) {
   
    const [items, setitems] = useState({ typenew: "", title: "", Name: "", company_id: props.companyid })
    const [typevalue, settypevalue] = useState()
    const [Mtype, setMtype] = useState([
        { label: "Cash", value: "1" },
        { label: "Bank", value: "2" },


    ])
    useEffect(() => {
      
    }, [])
 
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
        settypevalue(null)
        
        setitems({ typenew: "", title: "", Name: "", company_id: props.companyid });
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "Booking/AddMethod";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const submitButton = e.target.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.innerHTML = '<section><span class="loader-5"></span></section>';
      
        try {
          if (items.Mtype === "") {
            swal({
              title: "Type Required!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          if (items.title === "") {
            swal({
              title: "Title Required!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          items.company_id = props.companyid;
      
          await savemethod(items);
          // Reset the form
          // ...
      
          // Show success message
          swal({
            title: "Form submitted successfully!",
            icon: "success"
          });
        } catch (error) {
          // Show error message
          swal({
            title: "An error occurred!",
            text: error.message,
            icon: "error"
          });
        } finally {
          // Enable the submit button
          submitButton.disabled = false;
          // Reset the button text
          submitButton.innerHTML = "Submit";
        }
      };
      
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Method</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label htmlFor="form-label">Type *</label>
                                        <Select value={typevalue} options={Mtype} onChange={(e) => { settypevalue(e); setitems({ ...items, Mtype: e.value }) }} />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Bank Title *</label>
                                        <input type="text" className="form-control" name="title" autoComplete="off" value={items.title} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Person Name</label>
                                        <input type="text" className="form-control" name="Name" autoComplete="off" value={items.Name} onChange={handleInput} />
                                    </div>
                                   
                                   
                                </div>
                                <button type="submit" className="d-flex mx-auto btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}